export const MenuItemsPersonal = [
  {
    title: 'Car Insurance',
    link: '/car-insurance',
  },
  {
    title: 'Home Insurance',
    link: '/home-insurance',
  },
  {
    title: 'Health Insurance',
    link: '/health-insurance',
  },
  {
    title: 'Life Insurance',
    link: '/life-insurance',
  },
  {
    title: 'Travel Insurance',
    link: '/travel-insurance',
  },
  {
    title: 'Yacht Insurance',
    link: '/yacht-insurance',
  },
  {
    title: 'Bike Insurance',
    link: '/bike-insurance',
  },
];

export const MenuItemsBusiness = [
  {
    title: 'Group Health Insurance',
    link: '/group-health-insurance',
  },
  {
    title: 'Public Liability Insurance',
    link: '/public-liability-insurance',
  },
  {
    title: 'Professional Indeminity Insurance',
    link: '/professional-indemnity-insurance/',
  },
  {
    title: 'Workmen Compensation',
    link: '/workmen-compensation/',
  },
  {
    title: 'Group Life Insurance',
    link: '/group-life-insurance/',
  },
  {
    title: 'Marine Cargo Insurance',
    link: '/marine-cargo-insurance/',
  },
  {
    title: 'Medical Malpractice',
    link: '/medical-malpractice/',
  },
  {
    title: 'Motor Fleet Insurance',
    link: '/motor-fleet-insurance/',
  },
  {
    title: 'Property and Business Interruption',
    link: '/property-and-business/',
  },
  {
    title: 'Contractors Insurance',
    link: '/contractors-insurance/',
  },
  {
    title: 'Event Insurance',
    link: '/event-insurance/',
  },
  {
    title: 'Drone Insurance',
    link: '/drone-insurance/',
  },
  {
    title: 'Photographers Package Insurance',
    link: '/photographers-package-insurance/',
  },
  {
    title: 'Cyber Security Insurance',
    link: '/cyber-security-insurance/',
  },
];

export const MenuItemsAbout = [
  {
    title: 'Contact Us',
    link: '/contact-us/',
  },
  {
    title: 'FAQs',
    link: '/faq/',
  },
  {
    title: 'Leadership',
    link: '/leadership/',
  },
  {
    title: 'Our Story',
    link: '/our-story/',
  },
  {
    title: 'Privacy',
    link: '/privacy/',
  },
  {
    title: 'Careers',
    link: '/careers/',
  },
  {
    title: 'Media',
    link: '/media/',
  },
];

export const MenuItemsServices = [
  {
    title: 'Claims',
    link: '/claims/',
  },
];

export const MenuItemsResources = [
  {
    title: 'Insurance Glossary',
    link: '/glossary/',
  },
  {
    title: 'Guides',
    link: '/glossary/',
  },
];
